import { Table, Button } from "antd";
import type { ColumnsType } from "antd/lib/table";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { setOnViewDevice } from "Components/Report/reportSlice";
import { useAppDispatch, useAppSelector } from "store/hook";
import { health_top } from "Utility/Types/report";
import { useReportTop } from "Components/Report/queries";

const HealthTable = ({ param, id = "", isFetching }: { param: Parameter; id?: string; isFetching: boolean }) => {
  // const [visible, setVisible] = useState(false);
  const disp = useAppDispatch();
  const { title } = useChartParam(param, id);
  const { loginCid, stateCid, level } = useAppSelector((status) => status.global);
  const { filterForm } = useAppSelector((status) => status.report);
  const { data: top } = useReportTop({
    filterForm,
    loginCid,
    stateCid,
    level,
    type: "health_top",
  });

  const health = (top?.response?.[0]?.health_top || []) as health_top[];
  const columns: ColumnsType<health_top> = [
    {
      title: "Location",
      dataIndex: "location",
      ellipsis: true,
      // responsive: ["xxl"],
    },
    {
      title: "Device",
      width: 170,
      render: (_, record) => (
        <Button type="link" onClick={() => disp(setOnViewDevice(record.id))}>
          {record.name !== "" ? record.name : record.id}
        </Button>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      responsive: ["xxl"],
    },

    {
      title: "Offline",
      dataIndex: "offline",
      sorter: {
        compare: (a, b) => a.offline - b.offline,
        multiple: 3,
      },
      defaultSortOrder: "descend",
    },
    {
      title: "Critical",
      dataIndex: "critical",
      // sorter: (a, b) => a.critical - b.critical,
      defaultSortOrder: "descend",
      sorter: {
        compare: (a, b) => a.critical - b.critical,
        multiple: 2,
      },
    },
    {
      title: "Warning",
      dataIndex: "warning",
      sorter: {
        compare: (a, b) => a.warning - b.warning,
        multiple: 1,
      },
      // sorter: (a, b) => a.warning - b.warning,
      defaultSortOrder: "descend",
    },

    // {
    //   title: "Total",
    //   dataIndex: "total",
    //   render: (_: string, record) => record.warning + record.critical + record.offline,
    // },
  ];

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      <Table
        size="middle"
        columns={columns}
        dataSource={health}
        pagination={{ pageSize: 5, size: "small", showSizeChanger: false, showQuickJumper: true }}
        rowKey={(record) => record.id}
      />
    </ChartCard>
  );
};

export default HealthTable;
